e4.util = {
    init: function () {
        e4.util.catchInternalBackLinks();
        e4.util.catchBlockLinks();
    },
    isInViewport: function ( jElement ) {
        var domElm = jElement.get( 0 ),
            objBounds = domElm.getBoundingClientRect();
        return objBounds.top < window.innerHeight && objBounds.bottom > 0;
    },
    stringify: function ( objValue ) {
        return typeof objValue === 'string' ? objValue : JSON.stringify( objValue );
    },
    looksLikeUrl: function ( strValue ) {
        return strValue !== undefined && strValue !== null && ( e4.util.stringify( strValue ).indexOf( '/' ) === 0 || e4.util.stringify( strValue ).indexOf( 'http' ) === 0 );
    },
    formatStringToJavascriptNumber: function ( strNumber ) {
        return parseFloat( String( strNumber ).replace( new RegExp( '\\' + e4.settings.separatorInteger, 'g' ), '' ).replace( new RegExp( '\\' + e4.settings.separatorDecimal, 'g' ), '.' ) );
    },
    formatJavascriptNumberToLocaleString: function ( intNumber ) {
        var strNumber = String( parseFloat( Math.round( intNumber * 100 ) / 100 ).toFixed( 2 ) ).replace( /[^\d\.\-]/g, '' ).replace( /(\.\d{2})[\W\w]+/g, '$1' ).split( '' ).reverse().join( '' ).replace( /(\d{3})/g, '$1.' ).split( '' ).reverse().join( '' ).replace( /^([\-]{0,1})\./, '$1' ).replace( /\.(\d\d)$/, ',' + '$1' ).replace( /\.(\d)$/, ',' + '$1' + '0' ).replace( /\.$/, ',00' );
        if ( e4.settings.lang !== 'da' ) {
            strNumber = strNumber.replace( /\./g, '{integer}' );
            strNumber = strNumber.replace( /\,/g, '{decimal}' );
            strNumber = strNumber.replace( /{integer}/g, e4.settings.separatorInteger );
            strNumber = strNumber.replace( /{decimal}/g, e4.settings.separatorDecimal );
        }
        return strNumber;
    },
    ajax: function ( objAjaxSettings, fnCallback ) {
        var jqXHR = jQuery.ajax( jQuery.extend( {
                url: null,
                method: 'GET',
                dataType: 'json',
                cache: false,
            }, objAjaxSettings ) );
        jqXHR.done( function ( data ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( data );
            }
        } );
        jqXHR.fail( function () {
            console.trace( objAjaxSettings, arguments );
        } );
        return jqXHR;
    },
    debug: function ( objData, boolShow, strConsoleType ) {
        if ( boolShow === true || e4.settings.debug.show === true ) {
            var _strConsoleType = ( strConsoleType !== undefined && strConsoleType in console ) ? strConsoleType : e4.settings.debug.consoleType;
            if ( jQuery.isArray( objData ) === true ) {
                console[ _strConsoleType ].apply( null, objData );
            }
            else {
                console[ _strConsoleType ].call( null, objData );
            }
        }
    },
    registerEvents: function ( strEvents, strNamespaceLocal ) {
        var objEvents = {},
            strNamespace = [
                e4.settings.event.namespace,
                strNamespaceLocal
            ].join( '.' );
        jQuery.each( strEvents.split( ' ' ), function ( index, element ) {
            objEvents[ element ] = [
                element,
                strNamespace
            ].join( '.' );
        } );
        return objEvents;
    },
    debounce: function ( fnFunction, intDelay ) {
        var intDeferTimer = null;
        return function () {
            var thisArg = this,
                arrArgs = arguments;
            clearTimeout( intDeferTimer );
            intDeferTimer = setTimeout( function () {
                fnFunction.apply( thisArg, arrArgs );
            }, intDelay );
        };
    },
    catchInternalBackLinks: function () {
        jQuery( document ).on( 'click', '.js-e-back-link', function ( event ) {
            if ( document.referrer.indexOf( location.protocol + '//' + location.host ) === 0 ) {
                event.preventDefault();
                history.back();
            }
        } );
    },
    catchBlockLinks: function () {
        jQuery( document ).on( 'click', '.js-e-block-link', function ( event ) {
            var jBlockLink = jQuery( event.currentTarget ).find( 'a[href]' ).not( 'a[href="#"]' ).first();
            if ( jBlockLink.length === 1 && jQuery( event.target ).closest( 'a[href], form, .dropdown' ).length === 0 && window.getSelection().toString() === '' ) {
                if ( jBlockLink.attr( 'target' ) === '_blank' ) {
                    window.open( jBlockLink.attr( 'href' ) );
                }
                else {
                    location.href = jBlockLink.attr( 'href' );
                }
            }
        } );
    },
    getAllSubmitButtonsInForm: function ( domForm ) {
        return jQuery( domForm ).find( 'input[type="submit"],button' ).not( '[type="button"],[type="reset"]' );
    },
    enableAllSubmitButtonsInForm: function ( domForm ) {
        e4.util.getAllSubmitButtonsInForm( domForm ).prop( 'disabled', false );
    },
    disableAllSubmitButtonsInForm: function ( domForm ) {
        e4.util.getAllSubmitButtonsInForm( domForm ).prop( 'disabled', true );
    },
    observer: {
        _instances: [],
        isSupported: 'IntersectionObserver' in window,
        bind: function ( arrTargets, fnCallback, objOptions ) {
            if ( e4.util.observer.isSupported === true ) {
                var objInstance = {};
                objInstance.id = '_instance' + Math.random().toString( 36 ).substr( 2, 9 );
                objInstance.options = jQuery.extend( e4.settings.intersectionObserver.options, objOptions );
                objInstance.observer = new IntersectionObserver( function ( arrEntries, objObserver ) {
                    arrEntries.forEach( function ( objEntry ) {
                        if ( typeof fnCallback === 'function' ) {
                            fnCallback( objEntry, objObserver );
                        }
                        else {
                            e4.util.debug( 'No callback function defined', e4.settings.debug.show, 'warn' );
                        }
                    } );
                }, objInstance.options );
                arrTargets.forEach( function ( domTarget ) {
                    objInstance.observer.observe( domTarget );
                } );
                e4.util.observer._instances.push( objInstance );
            }
            else {
                e4.util.debug( 'IntersectionObserver not available', true, 'warn' );
            }
        },
        disconnect: function ( intInstanceIndex ) {
            e4.util.observer._instances[ intInstanceIndex ].observer.disconnect();
        }
    }
};
